import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import FooterAccordion from './FooterAccordion';

const Footer = () => {
  useEffect(() => {
    // Initialize any footer jQuery functionality if needed
    if (window.jQuery) {
      // Add any specific footer interactions here
    }
  }, []);

  return (
    <footer id="main_footer">
      <div id="top-footer">
        <div className="container-fluid px-3 px-md-5">
          <div className="row">
            {/* Column 1: Logo & About */}
            <div className="col-lg-3 fst-footer">
              <img src="images/logo/logo.avif" className="img-fluid mb-lg-4" alt="Gateway Financial Logo" />
              <p>
                Gateway Financial Services Limited is a dynamic financial advisory and investment solutions firm
                committed to helping individuals and businesses achieve their financial goals.{' '}
              </p>
              <Link to="/attention-investors" className="lm-btn">
                Attention Investor
              </Link>
            </div>

            {/* Column 2: Our Services */}
            <div className="col-lg-2 snd-footer">
              <h4>Our Services</h4>
              <ul className="footer-menu">
                <li>
                  <Link to="/mutual-funds">Mutual Funds</Link>
                </li>
                <li>
                  <Link to="/depository-services">Depository Services</Link>
                </li>
                <li>
                  <Link to="/fixed-income-products">Fixed Income Products</Link>
                </li>
                <li>
                  <Link to="/equity-commodity-trading">Equity &amp; Commodity Trading</Link>
                </li>
                <li>
                  <Link to="/global-investments">Global Investments</Link>
                </li>
                <li>
                  <Link to="/insurance-products">Insurance Products</Link>
                </li>
              </ul>

              <ul className="footer-app-list">
                <li className="mb-1">
                  <img src="images/app-img1.png" className="img-fluid" alt="Download on App Store" />
                </li>
                <li className="mb-1">
                  <img src="images/app-img2.png" className="img-fluid" alt="Get it on Google Play" />
                </li>
              </ul>
            </div>

            {/* Column 3: Others */}
            <div className="col-lg-2">
              <h4>Others</h4>
              <ul className="footer-menu2">
                <li>
                  <Link to="/downloads">Downloads</Link>
                </li>
                <li>
                  <Link to="/policies">Policies</Link>
                </li>
                <li>
                  <Link to="/advisory-for-investors">Advisory for Investors</Link>
                </li>
                <li>
                  <Link to="/attention-investors">Attention Investors</Link>
                </li>
                <li>
                  <Link to="/risk-disclosures-of-derivatives">Risk Disclosures of Derivatives</Link>
                </li>
                <li>
                  <Link to="/notice">Notice</Link>
                </li>
                <li>
                  <Link to="/know-your-kyc">Know your KYC</Link>
                </li>
                <li>
                  <Link to="/client-registration-documents">Client Registration Documents in Vernacular</Link>
                </li>
                <li>
                  <Link to="/investor-relations">Investor Relations</Link>
                </li>
                <li>
                  <Link to="/client-bank-account">Client Bank Account</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">Terms and Conditions</Link>
                </li>
                <li>
                  <Link to="/grievance-redressal-mechanism">Grievance Redressal Mechanism</Link>
                </li>{' '}
                {/* Fixed Typo */}
              </ul>
            </div>

            {/* Column 4: Quick Links */}
            <div className="col-lg-2">
              <h4>Quick Links</h4>
              <ul className="footer-menu2">
                {/* Added rel="noopener noreferrer" to all external links */}
                <li>
                  <a href="https://www.sebi.gov.in/" target="_blank" rel="noopener noreferrer">
                    SEBI
                  </a>
                </li>
                <li>
                  <a href="https://www.nseindia.com/" target="_blank" rel="noopener noreferrer">
                    NSE
                  </a>
                </li>
                <li>
                  <a href="https://www.bseindia.com/" target="_blank" rel="noopener noreferrer">
                    BSE
                  </a>
                </li>
                <li>
                  <a href="https://www.mcxindia.com/" target="_blank" rel="noopener noreferrer">
                    MCX
                  </a>
                </li>
                <li>
                  <a href="https://nsdl.co.in/" target="_blank" rel="noopener noreferrer">
                    NSDL
                  </a>
                </li>
                <li>
                  <a href="https://www.icexindia.com/" target="_blank" rel="noopener noreferrer">
                    ICEX
                  </a>
                </li>
                <li>
                  <a href="https://www.ncdex.com/" target="_blank" rel="noopener noreferrer">
                    NCDEX
                  </a>
                </li>
                <li>
                  <a href="https://scores.sebi.gov.in/" target="_blank" rel="noopener noreferrer">
                    Scores
                  </a>
                </li>
                <li>
                  <a href="https://smartodr.in/login" target="_blank" rel="noopener noreferrer">
                    Smart ODR
                  </a>
                </li>
                <li>
                  <Link to="/kra">KRA</Link>
                </li>
                <li>
                  <a href="https://login.irra.live/stocks/jsp/irra/" target="_blank" rel="noopener noreferrer">
                    IRRA Link
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.evoting.nsdl.com/eVotingWeb/commonhtmls/Login.jsp"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    E-Voting [NSDL]
                  </a>
                </li>
                <li>
                  <a
                    href="https://investorhelpline.nseclearing.in/ClientCollateral/welcomeCLUser"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Client Collateral (NSE)
                  </a>
                </li>
                <li>
                  <a href="https://clientreports.mcxccl.com/#/" target="_blank" rel="noopener noreferrer">
                    Client Collateral (MCX)
                  </a>
                </li>
                <li>
                  <a href="https://pledge.mygov.in/cvc/" target="_blank" rel="noopener noreferrer">
                    Vigilance Awareness
                  </a>
                </li>
                <li>
                  <a
                    href="/pdf/Annexue 5 - SEBI Master  Circular  for Online  Resolution  of  Disputes - December 28, 2023.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ODR Circular
                  </a>
                </li>
              </ul>
            </div>

            {/* Column 5: Contact Us */}
            <div className="col-lg-3 trd-footer">
              <h4>Contact Us</h4>
              <p className="mb-2">Jasmine Tower, 31, Shakespeare Sarani 2nd Floor, Kolkata : 700017</p>
              <p className="mb-0">Phone: 033- 2289 4461</p>
              <p>Email: admin@gatewayfin.in</p>
              <ul className="footer-social">
                <li>
                  <a href="https://gatewayfin.in/www.facebook.com" target="_blank" rel="noreferrer">
                    <i className="fa fa-facebook" aria-hidden="true" />
                  </a>
                </li>
                <li>
                  <a href="https://gatewayfin.in/www.instagram.in" target="_blank" rel="noreferrer">
                    <i className="fa fa-instagram" aria-hidden="true" />
                  </a>
                </li>
                <li>
                  <a href="https://gatewayfin.in/www.youtube.com" target="_blank" rel="noreferrer">
                    <i className="fa fa-youtube" aria-hidden="true" />
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Accordion & Notice Ticker */}
          <div className="row ft-ctn">
            <div className="col-lg-12">
              <FooterAccordion />
            </div>

            <div className="col-lg-12 mt-4">
              {/* CSS Animated Marquee Replacement */}
              <div className="custom-marquee-container">
                <div className="custom-marquee-track">
                  <ul className="custom-marquee-content">
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> Stock Brokers can accept securities as
                      margin from clients only by way of pledge in the depository system w.e.f. September 01, 2020.
                    </li>
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> Check your securities / MF / bonds in the
                      consolidated account statement issued by NSDL/CDSL every month Issued in the interest of
                      Investors.
                    </li>
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> All clients are requested to record their
                      email id for electronic dispatch of contract and statement. In case of electronic contract note,
                      the link/login for the same is available on website for download.
                    </li>
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> Pay 20% upfront margin of the transaction
                      value to trade in the cash market segment. Investors may please refer to the Exchange's Frequently
                      Asked Questions (FAQs) issued vide circular reference NSE/INSP/45191 dated July 31, 2020 and
                      NSE/INSP/45534 dated August 31, 2020 and other guidelines issued from time to time in this regard.
                    </li>
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> No need to issue cheques by investors
                      while subscribing to IPO. Just write the bank account number and sign in the application form to
                      authorize your bank to make payment in case of allotment. No worries for refund as the money
                      remains in investors account.
                    </li>
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> Submit application letter along with
                      photocopy of PAN and address proof requesting activation of Dormant Account.
                    </li>
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> All clients are requested to providing the
                      NEFT details of your bank account for receiving directly credit to your account by online. Please
                      submit a cancel cheque in your operating branch.
                    </li>
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> Unauthorized Transactions in your demat
                      account → Update your Mobile Number with your Depository Participant. Receive alerts on your
                      Registered Mobile for all debit and other important transactions in your demat account directly
                      from NSDL.
                    </li>
                  </ul>
                  {/* Duplicate list to ensure seamless infinite looping */}
                  <ul className="custom-marquee-content" aria-hidden="true">
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> Stock Brokers can accept securities as
                      margin from clients only by way of pledge in the depository system w.e.f. September 01, 2020.
                    </li>
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> Check your securities / MF / bonds in the
                      consolidated account statement issued by NSDL/CDSL every month Issued in the interest of
                      Investors.
                    </li>
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> All clients are requested to record their
                      email id for electronic dispatch of contract and statement. In case of electronic contract note,
                      the link/login for the same is available on website for download.
                    </li>
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> Pay 20% upfront margin of the transaction
                      value to trade in the cash market segment. Investors may please refer to the Exchange's Frequently
                      Asked Questions (FAQs) issued vide circular reference NSE/INSP/45191 dated July 31, 2020 and
                      NSE/INSP/45534 dated August 31, 2020 and other guidelines issued from time to time in this regard.
                    </li>
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> No need to issue cheques by investors
                      while subscribing to IPO. Just write the bank account number and sign in the application form to
                      authorize your bank to make payment in case of allotment. No worries for refund as the money
                      remains in investors account.
                    </li>
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> Submit application letter along with
                      photocopy of PAN and address proof requesting activation of Dormant Account.
                    </li>
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> All clients are requested to providing the
                      NEFT details of your bank account for receiving directly credit to your account by online. Please
                      submit a cancel cheque in your operating branch.
                    </li>
                    <li>
                      <i className="fa fa-dot-circle-o" aria-hidden="true" /> Unauthorized Transactions in your demat
                      account → Update your Mobile Number with your Depository Participant. Receive alerts on your
                      Registered Mobile for all debit and other important transactions in your demat account directly
                      from NSDL.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="footer-copyright">
        <div className="container-fluid px-5">
          <div className="row">
            <div className="col-lg-12 text-center">
              <p className="mb-0">Copyright © Gateway Financial Services Ltd. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
